import React, { useState } from "react";
import Table from "react-bootstrap/Table";
import { TableActionButton } from "../components";
import { TableShimmer } from "./Shimmer";
import DataNotFound from "./DataNotFound/DataNotFound";

const CommonTable = ({
  columns,
  data,
  actions,
  itemsPerPage = 50,
  loading,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastPost = currentPage * itemsPerPage;
  const indexOfFirstPost = indexOfLastPost - itemsPerPage;
  const currentItems = data.slice(indexOfFirstPost, indexOfLastPost);

  return (
    <div className="table-data-main">
      {loading ? (
        <div className="loader-container">
          <TableShimmer />
        </div>
      ) : data.length === 0 ? (
        <div className="no-data">
          <DataNotFound message="No records found" />
        </div>
      ) : (
        <>
          <Table responsive>
            <thead>
              <tr>
                {columns.map((col, index) => (
                  <th key={index}>{col.label}</th>
                ))}
                {actions && <th></th>}
              </tr>
            </thead>
            <tbody>
              {currentItems.map((item, key) => (
                <tr key={key}>
                  {columns.map((col, index) => (
                    <td key={index}>
                      <div className="user-info">
                        {col.key === "status" ? (
                          <span
                            className={`${
                              item.status === "Active"
                                ? "approved"
                                : item.status === "Deactive"
                                ? "rejected"
                                : ""
                            }`}
                          >
                            {item[col.key] || "N/A"}
                          </span>
                        ) : col.key == "verification_status" ? (
                          <span
                            className={`${
                              item?.verification_status == "Verified"
                                ? "approved"
                                : item?.verification_status == "Pending"
                                ? "pending"
                                : item?.verification_status == "Rejected"
                                ? "rejected"
                                : item?.verification_status ==
                                  "Verification Requested"
                                ? "delivery-pending"
                                : ""
                            }`}
                          >
                            {item?.verification_status}
                          </span>
                        ) : (
                          <p className="table-cell">
                            {item[col.key]
                              ? item[col.key].toString().length > 16
                                ? item[col.key].toString().slice(0, 16) + "..."
                                : item[col.key]
                              : "N/A"}
                          </p>
                        )}
                      </div>
                    </td>
                  ))}

                  {actions && (
                    <td>
                      <div className="table-inner-grid-dta">
                        <div className="btn-table-new">
                          <div className="btn-dis-new">
                            <TableActionButton
                              options={actions(item)}
                              isOpen={true}
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="paginate_all_common"></div>
        </>
      )}
    </div>
  );
};

export default CommonTable;
